module.exports = __webpack_public_path__ + "img/okta.9c36fc18.png";